import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserStockModel } from './userStock.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { UserCompanyService } from '../usercompany/usercompany.service';
import { MatDialog } from '@angular/material/dialog';
import { UserStockLoginComponent } from './userStock-login.component';

@Component({
    selector: 'convfact-userStock-form',
    templateUrl: './userStock-form.component.html',
    styleUrls: [],
    standalone: false
})

export class UserStockFormComponent implements OnInit {
  @Input() userStock: UserStockModel;
  @Input() errors: object;
  @Output() onSave = new EventEmitter<any>();
  ready = false;

  constructor(
    public userCompanyService: UserCompanyService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.ready = true;
  }

  generarToken() {
    this.dialog.open(UserStockLoginComponent, {})
      .afterClosed().subscribe(result => { 
        if (result != null) {
          this.userStock.token = result.token;
          // this.userStock.expired = result.expired;
          this.onSave.emit(this.userStock);
        }
      });
  }

  comprobarToken() {

  }
}
